import EditHeadOfCaseLightBoxContainer from './EditHeadOfCaseLightBoxContainer';

export default EditHeadOfCaseLightBoxContainer;
